import axios from 'axios'
import router from './router'
import {Message} from 'element-ui'
// axios 配置
axios.defaults.timeout = 30000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 设置拦截器
// 在header中增加授权token的拦截器
axios.interceptors.request.use(
  config => {
    let tokenInfo = window.localStorage.getItem('token_info')
    if (tokenInfo) {
      config.headers.Authorization = 'Bearer ' + JSON.parse(tokenInfo).access_token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })

// 401错误的时候
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 清除token，并跳转
          Message.info('您目前处于未登录状态，请先登录！😊')
          window.localStorage.removeItem('token_info')
          router.push('/user/login')
          break
        case 404:
          Message.warning('未找到对应资源文件')
          break
        case 500:
          // 系统内部错误
          Message.error('抱歉，系统内部错误，请稍后重试，或者联系工作人员解决！')
          break
        case 507:
          // 空间资源不足
          Message.warning('用户资源空间不足，请升级套餐进行扩容，或者清理部分空间后重试。')
          break
        }
    } else {
      // 请求超时，后台服务器宕机
      Message.error('服务器链接出现异常，请检查网络，或者稍后重试！')
    }
    return Promise.reject(error)
  })

export default axios
